import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';

const AccountSettings: React.FC = () => {
    const coverImageInputRef = useRef<HTMLInputElement>(null);
    const profileImageInputRef = useRef<HTMLInputElement>(null);
    const companyLogoInputRef = useRef<HTMLInputElement>(null);

    const handleCoverImageClick = () => {
        coverImageInputRef.current?.click();
    };

    const handleProfileImageClick = () => {
        profileImageInputRef.current?.click();
    };

    const handleCompanyLogoClick = () => {
        companyLogoInputRef.current?.click();
    };

    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Account Settings</h6>
                        <p className="text-secondary small">Make sure your profile is updated</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi"><Link to="/app/my-profile"> My Profile</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page"> Account Settings</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                <ul className="nav nav-sm nav-pills overflow-x-auto w-100 text-nowrap flex-nowrap pb-3" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="personal-tab" data-bs-toggle="tab" data-bs-target="#personal" type="button" role="tab" aria-controls="personal" aria-selected="true">Personal</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Profile</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="payment-tab" data-bs-toggle="tab" data-bs-target="#payment" type="button" role="tab" aria-controls="payment" aria-selected="false">Payments</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="emailsocials-tab" data-bs-toggle="tab" data-bs-target="#emailsocials" type="button" role="tab" aria-controls="emailsocials" aria-selected="false">Email & Socials</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="taxinfo-tab" data-bs-toggle="tab" data-bs-target="#taxinfo" type="button" role="tab" aria-controls="taxinfo" aria-selected="false">Tax Information</button>
                    </li>
                </ul>
                <div className="tab-content" id="myTabContent">

                    {/* personal info tab*/}
                    <div className="tab-pane fade show active" id="personal" role="tabpanel">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="">
                                    <figure className="coverimg w-100 height-140 mb-0 position-relative rounded mb-0">
                                        <div className="position-absolute top-0 end-0 m-3">
                                            <input type="file" className="form-control d-none" ref={coverImageInputRef} />
                                            <button className="btn btn-sm btn-theme" onClick={handleCoverImageClick}><i className="bi bi-camera"></i> Change Cover</button>
                                        </div>
                                        <img src={asset('assets/img/background-image/backgorund-image-3.jpg')} className="mw-100" alt="" />
                                    </figure>
                                    <div className="row gx-3 gx-lg-4 align-items-start justify-content-center mt--50 mb-3">
                                        <div className="col-auto position-relative">
                                            <figure className="avatar avatar-100 coverimg rounded-circle shadow-md border border-4 border-theme-1">
                                                <img src={asset('assets/img/adminuiux/user-1.jpg')} alt="" />
                                            </figure>
                                            <div className="position-absolute bottom-0 end-0 z-index-1 me-3 mb-1 h-auto">
                                                <input type="file" className="form-control d-none" ref={profileImageInputRef} />
                                                <button className="btn btn-theme btn-square shadow-sm rounded-circle" onClick={handleProfileImageClick}><i className="bi bi-camera"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h6 className="mb-3 mb-lg-4">Basic Details</h6>
                                <div className="row gx-3 gx-lg-4 mb-3">
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="First Name" value="DevUIUX" required className="form-control" />
                                                <label>First Name</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Last Name" value="" required className="form-control" />
                                                <label>Last Name</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="email" placeholder="Email Address" value="guest@adminuiux.com" disabled required className="form-control" />
                                                <label>Email Address</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback mb-3">Add .com at last to insert valid data </div>
                                    </div>
                                </div>

                                <h6 className="mb-3 mb-lg-4">Address Details</h6>
                                <div className="row mb-3">
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Address Line 1" value="" required className="form-control" />
                                                <label>Address Line 1</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="email" placeholder="Address Line 2" required className="form-control" />
                                                <label>Address Line 2</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback mb-3">Add insert valid data </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Landmark" required className="form-control" />
                                                <label>Landmark</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="email" placeholder="Street" required className="form-control" />
                                                <label>Street</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback mb-3">Add insert valid data </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Country" value="" required className="form-control" />
                                                <label>Country</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Pincode" value="" required className="form-control" />
                                                <label>Pincode</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="State" value="" required className="form-control" />
                                                <label>State</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="City" value="" required className="form-control" />
                                                <label>City</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                </div>

                                <h6 className="mb-3 mb-lg-4">Company Details</h6>
                                <div className="row mb-3">
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Company name" value="" required className="form-control" />
                                                <label>Company name</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="email" placeholder="Company Registration" required className="form-control" />
                                                <label>Company Registration</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback mb-3">Add insert valid data </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="email" placeholder="Company ID" required className="form-control" />
                                                <label>Company ID</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback mb-3">Add insert valid data </div>
                                    </div>

                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Address Line 1" value="" required className="form-control" />
                                                <label>Address Line 1</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="email" placeholder="Address Line 2" required className="form-control" />
                                                <label>Address Line 2</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback mb-3">Add insert valid data </div>
                                    </div>

                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Landmark" required className="form-control" />
                                                <label>Landmark</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="email" placeholder="Street" required className="form-control" />
                                                <label>Street</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback mb-3">Add insert valid data </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Country" value="" required className="form-control" />
                                                <label>Country</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Pincode" value="" required className="form-control" />
                                                <label>Pincode</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="State" value="" required className="form-control" />
                                                <label>State</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="City" value="" required className="form-control" />
                                                <label>City</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                </div>

                                {/* submit button */}
                                <div className="row gx-3">
                                    <div className="col">
                                        <button className="btn btn-theme" type="button">Submit</button>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-link theme-red" type="button">Cancel</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* profile tab*/}
                    <div className="tab-pane fade" id="profile" role="tabpanel">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <h6 className="mb-3 mb-lg-4">Company details</h6>
                                <div className="row gx-3 gx-lg-4 justify-content-center align-items-center mb-3 mb-lg-4">
                                    <div className="col-12 col-md-6 col-lg-4 mb-3">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <div className="avatar avatar-100 text-center rounded">
                                                    <img src={asset('assets/img/logo-512.png')} alt="" className="mw-100" id="companylogolight" />
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div>
                                                    <label htmlFor="companylogolightinput" className="form-label">Upload company logo (Light layout)</label><br />
                                                    <input className="form-control d-none" accept="image/*" type="file" id="companylogolightinput" ref={companyLogoInputRef} />
                                                    <button className="btn btn-sm btn-theme" onClick={handleCompanyLogoClick}><i className="bi bi-camera"></i> Upload</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group my-2 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Company Name" value="DevUIUX" required className="form-control" />
                                                <label>Company Name</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group my-2 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Company Tagline" value="Admin app UI" required className="form-control" />
                                                <label>Company Tagline</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                </div>
                                <h6 className="mb-3 mb-lg-4">Profile details</h6>
                                <div className="row gx-3 gx-lg-4 mb-3">
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="UserName" value="DevUIUX" required className="form-control" />
                                                <label>UserName</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-8">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Tagline" value="" required className="form-control" />
                                                <label>Tagline</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Headline" value="" required className="form-control" />
                                                <label>Headline</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <textarea placeholder="About me" rows={5} className="form-control h-auto"></textarea>
                                                <label>About me</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                </div>
                                <h6 className="mb-3 mb-lg-4">Public Visibility</h6>
                                <div className="row mb-3 mb-lg-4">
                                    <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="profileswitch1" checked />
                                            <label className="form-check-label" htmlFor="profileswitch1">Show my profile publicly</label>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="profileswitch2" defaultChecked />
                                            <label className="form-check-label" htmlFor="profileswitch2">Show my availability</label>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="profileswitch3" />
                                            <label className="form-check-label" htmlFor="profileswitch3">Show tagline in profile</label>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="profileswitch4" />
                                            <label className="form-check-label" htmlFor="profileswitch4">Make profile inactive</label>
                                        </div>
                                    </div>
                                </div>
                                {/* submit button */}
                                <div className="row gx-3">
                                    <div className="col">
                                        <button className="btn btn-theme" type="button">Submit</button>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-link theme-red" type="button">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* payment tab*/}
                    <div className="tab-pane fade" id="payment" role="tabpanel">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="collapse show" id="addcard">
                                    <div className="card border bg-theme-1-subtle theme-blue mb-3">
                                        <div className="card-header">
                                            <h6>Add new card</h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="row gx-3">
                                                <div className="col-12 col-md-6 col-lg-4">
                                                    <div className="row mb-3">
                                                        <div className="col-7">
                                                            <div className="form-group position-relative check-valid">
                                                                <div className="form-floating">
                                                                    <input type="text" placeholder="Card Number" value="" required className="form-control" />
                                                                    <label>Card Number</label>
                                                                </div>
                                                            </div>
                                                            <div className="invalid-feedback">Please enter valid input</div>
                                                        </div>
                                                        <div className="col-5">
                                                            <div className="form-group position-relative check-valid">
                                                                <div className="form-floating">
                                                                    <input type="text" placeholder="Code" value="205" required className="form-control" />
                                                                    <label>Code</label>
                                                                </div>
                                                            </div>
                                                            <div className="invalid-feedback">Please enter valid input</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-4">
                                                    <div className="row mb-3">
                                                        <div className="col-7">
                                                            <div className="form-group position-relative check-valid">
                                                                <div className="form-floating">
                                                                    <select className="form-select">
                                                                        <option>January</option>
                                                                        <option>February</option>
                                                                        <option>March</option>
                                                                        <option>April</option>
                                                                        <option>May</option>
                                                                        <option>June</option>
                                                                        <option>July</option>
                                                                        <option>August</option>
                                                                        <option>September</option>
                                                                        <option>October</option>
                                                                        <option>November</option>
                                                                        <option>December</option>
                                                                    </select>
                                                                    <label>Expiry month</label>
                                                                </div>
                                                            </div>
                                                            <div className="invalid-feedback">Please enter valid input</div>
                                                        </div>
                                                        <div className="col-5">
                                                            <div className="form-group position-relative check-valid">
                                                                <div className="form-floating">
                                                                    <select className="form-select">
                                                                        <option selected>2022</option>
                                                                        <option>2023</option>
                                                                        <option>2024</option>
                                                                        <option>2025</option>
                                                                        <option>2026</option>
                                                                        <option>2027</option>
                                                                        <option>2028</option>
                                                                        <option>2029</option>
                                                                    </select>
                                                                    <label>Expiry year</label>
                                                                </div>
                                                            </div>
                                                            <div className="invalid-feedback">Please enter valid input</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-4">
                                                    <div className="form-group position-relative check-valid">
                                                        <div className="form-floating">
                                                            <input type="text" placeholder="Card Holder" required className="form-control" />
                                                            <label>Card Holder</label>
                                                        </div>
                                                    </div>
                                                    <div className="invalid-feedback">Please enter valid input</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <button className="btn btn-theme" type="button">Add Card</button>
                                            <button className="btn btn-white ms-1" type="button" data-bs-toggle="collapse" data-bs-target="#addcard">Cancel</button>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <div className="row gx-3 align-items-center">
                                        <div className="col">
                                            <h6>My cards</h6>
                                        </div>
                                        <div className="col-auto">
                                            <button className="btn btn-sm btn-link" type="button" data-bs-toggle="collapse" data-bs-target="#addcard" aria-expanded="true" aria-controls="addcard">
                                                <i className="bi bi-plus"></i> Add Card
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <Swiper
                                    slidesPerView="auto"
                                    spaceBetween={18}
                                    className="swipernav overflow-visible mb-3 mb-lg-4"
                                >
                                    <SwiperSlide style={{ width: '240px' }}>
                                        <div className="card mb-2 theme-blue bg-theme-1 overflow-hidden">
                                            <div className="card-body position-relative z-index-1">
                                                <div className="row gx-3 align-items-center mb-4">
                                                    <div className="col-auto align-self-center">
                                                        <i className="bi bi-amazon fs-4"></i>
                                                    </div>
                                                    <div className="col text-end">
                                                        <p className="fs-12">
                                                            <span className="opacity-75 small">City Bank</span><br />
                                                            <span className="">Credit Card</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <p className="fw-medium h6 mb-3">
                                                    000 0000 0001 546598
                                                </p>
                                                <div className="row gx-3 gx-lg-4">
                                                    <div className="col-auto fs-12">
                                                        <p className="mb-0 opacity-75 small">Expiry</p>
                                                        <p>09/023</p>
                                                    </div>
                                                    <div className="col text-end fs-12">
                                                        <p className="mb-0 opacity-75 small">Card Holder</p>
                                                        <p>DevUIUX</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row gx-3 gx-lg-4">
                                            <div className="col">
                                                <p className="text-secondary small mb-1">Expense</p>
                                                <p>1500.00 <small className="text-theme-1 theme-green">18.0% <i className="bi bi-arrow-up"></i></small></p>
                                            </div>
                                            <div className="col-auto text-end">
                                                <p className="text-secondary small mb-1">Limit Remain</p>
                                                <p>13500.00</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide style={{ width: '240px' }}>
                                        <div className="card theme-teal bg-theme-1 mb-2 overflow-hidden">
                                            <div className="card-body position-relative z-index-1">
                                                <div className="row gx-3 align-items-center mb-4">
                                                    <div className="col-auto align-self-center">
                                                        <i className="bi bi-apple fs-4"></i>
                                                    </div>
                                                    <div className="col text-end">
                                                        <p className="fs-12">
                                                            <span className="opacity-75 small">City Bank</span><br />
                                                            <span className="">Debit Card</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <p className="fw-medium h6 mb-3">
                                                    000 0000 0001 546598
                                                </p>
                                                <div className="row gx-3 gx-lg-4">
                                                    <div className="col-auto fs-12">
                                                        <p className="mb-0 opacity-75 small">Expiry</p>
                                                        <p>09/023</p>
                                                    </div>
                                                    <div className="col text-end fs-12">
                                                        <p className="mb-0 opacity-75 small">Card Holder</p>
                                                        <p>DevUIUX</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row gx-3 gx-lg-4">
                                            <div className="col">
                                                <p className="text-secondary small mb-1">Expense</p>
                                                <p>3650.00 <small className="text-danger">11.0% <i className="bi bi-arrow-down"></i></small></p>
                                            </div>
                                            <div className="col-auto text-end">
                                                <p className="text-secondary small mb-1">Limit Remain</p>
                                                <p>35500.00</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide style={{ width: '240px' }}>
                                        <div className="card theme-orange bg-theme-1 mb-2">
                                            <div className="card-body">
                                                <div className="row gx-3 align-items-center mb-4">
                                                    <div className="col-auto align-self-center">
                                                        <i className="bi bi-amazon fs-4"></i>
                                                    </div>
                                                    <div className="col text-end">
                                                        <p className="fs-12">
                                                            <span className="opacity-75 small">City Bank</span><br />
                                                            <span className="">Credit Card</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <p className="fw-medium h6 mb-3">
                                                    000 0000 0001 546598
                                                </p>
                                                <div className="row gx-3 gx-lg-4">
                                                    <div className="col-auto fs-12">
                                                        <p className="mb-0 opacity-75 small">Expiry</p>
                                                        <p>09/023</p>
                                                    </div>
                                                    <div className="col text-end fs-12">
                                                        <p className="mb-0 opacity-75 small">Card Holder</p>
                                                        <p>DevUIUX</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row gx-3 gx-lg-4">
                                            <div className="col">
                                                <p className="text-secondary small mb-1">Expense</p>
                                                <p>1500.00 <small className="text-theme-1 theme-green">18.0 <i className="bi bi-arrow-up"></i></small></p>
                                            </div>
                                            <div className="col-auto text-end">
                                                <p className="text-secondary small mb-1">Limit Remain</p>
                                                <p>13500.00</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>

                                <h6 className="mb-3 mb-lg-4">PayPal Address <small className="text-secondary fw-normal">(Provide to receive payouts)</small></h6>
                                <div className="row mb-3">
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="email" placeholder="Email" value="testmail@adminuiux.com" required className="form-control" />
                                                <label>Email</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4 align-self-center">
                                        <p className="mb-2 text-success"><i className="bi bi-patch-check me-1"></i> Verified</p>
                                    </div>
                                </div>
                                {/* submit button */}
                                <div className="row gx-3">
                                    <div className="col">
                                        <button className="btn btn-theme" type="button">Submit</button>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-link theme-red" type="button">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* email and social tab*/}
                    <div className="tab-pane fade" id="emailsocials" role="tabpanel">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <h6 className="mb-3 mb-lg-4">Website </h6>
                                <div className="row gx-3 mb-3">
                                    <div className="col-12 col-md-12 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="text" placeholder="Provide website url" value="https://www.adminuiux.com" required className="form-control" />
                                                <label>Website</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                </div>

                                <h6 className="mb-3 mb-lg-4">Social account <small className="text-secondary fw-normal">(Provide username, page name only)</small></h6>
                                <div className="row gx-3 mb-3">
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="email" placeholder="Provide twitter username" value="adminuiux" required className="form-control" />
                                                <label>Twitter</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="email" placeholder="Provide Facebook username" value="adminuiux" required className="form-control" />
                                                <label>Facebook</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="email" placeholder="Provide Linkdein username" value="adminuiux" required className="form-control" />
                                                <label>LinkdeIn</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div className="form-group mb-3 position-relative check-valid">
                                            <div className="form-floating">
                                                <input type="email" placeholder="Provide Pinterest username" value="adminuiux" required className="form-control" />
                                                <label>Pinterest</label>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">Please enter valid input</div>
                                    </div>
                                </div>

                                <h6 className="mb-3 mb-lg-4">Email settings </h6>
                                <ul className="list-group list-group-flush bg-none mb-4">
                                    <li className="list-group-item">
                                        <div className="row gx-3">
                                            <div className="col">Show emails to publicly</div>
                                            <div className="col-auto">
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input" type="checkbox" id="emailsocial1" />
                                                    <label className="form-check-label" htmlFor="emailsocial1"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="list-group-item">
                                        <div className="row gx-3">
                                            <div className="col">Send an email reminding me to rate an item a week after purchase</div>
                                            <div className="col-auto">
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input" type="checkbox" id="emailsocial2" defaultChecked />
                                                    <label className="form-check-label" htmlFor="emailsocial2"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="list-group-item">
                                        <div className="row gx-3">
                                            <div className="col">Send an email when an item I've purchased is updated</div>
                                            <div className="col-auto">
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input" type="checkbox" id="emailsocial3" defaultChecked />
                                                    <label className="form-check-label" htmlFor="emailsocial3"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="list-group-item">
                                        <div className="row gx-3">
                                            <div className="col">Send me a daily summary of all items approved or rejected</div>
                                            <div className="col-auto">
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input" type="checkbox" id="emailsocial4" />
                                                    <label className="form-check-label" htmlFor="emailsocial4"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <div className="row gx-3">
                                    <div className="col">
                                        {/* submit button */}
                                        <button className="btn btn-theme" type="button">Submit</button>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-link theme-red" type="button">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* tax information tab*/}
                    <div className="tab-pane fade" id="taxinfo" role="tabpanel">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="card adminuiux-card border border-theme-1 bg-l-gradient-light theme-green mb-3 mb-lg-4">
                                    <div className="card-body p-3">
                                        <h6>You successfully submitted your tax information on 25 Jun 2021 18:26:20 UTC.</h6>
                                        <p className="small">Your tax information will expire on 1st July 2025. Please re-submit your form before expiry.</p>
                                        <p className="small">If you wish to update these details, please re-submit the form below.</p>

                                        <p className='small' >For questions relating to why we need this information,<br />please check our help center for <a>W-9</a>, <a>W-8</a> articles or email <a>testmail@axartkiller.com</a>.</p>
                                    </div>
                                </div>
                                <p>US federal tax law requires getDevUIUX to collect US Author tax information through an IRS Form W-9 and report on income paid.</p>
                                <br />
                                <h5>If you are a U.S. Person</h5>
                                <p>No matter where you are worldwide you can submit a Form W-9 to getDevUIUX to satisfy your filing requirement. Typically there will be no withholding of taxes on any of your getDevUIUX income. If you do not submit a valid Form W-9, getDevUIUX will be required to deduct 24% withholding tax from sales proceeds and remit these directly to the Internal Revenue Service. If you have any questions, please check our help center for W-9 articles.</p>
                                <br />
                                <h5>If you are not a U.S. Person</h5>
                                <p>You will need to submit a Form W-8. If you are a resident of a country that has a tax treaty with the U.S., you will benefit from the reduced or zero withholding rate that is specified in your country's tax treaty. If you are a resident of a country that does not have a tax treaty with the U.S., then your U.S. source income from DevUIUX will be subject to a 30% withholding tax. If you have any questions, please check our help center for W-8
                                    articles.
                                </p>
                                <br />
                                <p>While getDevUIUX cannot give tax and/or legal advice, we will do our best to provide you with the information you need to make your own decision about how to comply with applicable U.S. tax laws. If you still have questions after reviewing the information provided by the IRS, please contact your legal and/or tax advisor.</p>

                                <p>Please indicate whether you are a US Person and we will direct you to the correct Forms. More information- An individual who is a US citizen or US resident alien, or who satisfies the substantial presence test.</p>

                                <p>- A partnership, corporation, company, or association created or organized in the United States or under the laws of the United States.</p>

                                <p>- An estate (other than a foreign estate), or</p>

                                <p>- A domestic trust (as defined in US tax regulations).</p>
                                <br />
                                <ul className="list-group list-group-flush bg-none mb-3 mb-lg-4">
                                    <li className="list-group-item">
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" name="usnoneus" type="radio" id="usnoneus1" checked />
                                            <label className="form-check-label" htmlFor="usnoneus1">I am a US Person</label>
                                        </div>
                                    </li>
                                    <li className="list-group-item">
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" name="usnoneus" type="radio" id="usnoneus2" />
                                            <label className="form-check-label" htmlFor="usnoneus2">I am not a US Person</label>
                                        </div>
                                    </li>
                                </ul>
                                <div className="row gx-3">
                                    <div className="col">
                                        {/* submit button */}
                                        <button className="btn btn-theme" type="button">Submit</button>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-link theme-red" type="button">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AccountSettings;
